import { selectCurrentHotelId } from 'accessors'
import { useSelector } from 'react-redux'

const resortNearDisneyHotelId = '08db52e8-9d6e-4242-89f0-9737b0b112fa'

function useResortNearDisney() {
  const currentHotelId = useSelector(selectCurrentHotelId)

  return currentHotelId === resortNearDisneyHotelId
}

export default useResortNearDisney
